import { Lms } from "@verity/api-client/types";
import i18n from "../i18n";

export function getLmsName(lms?: Lms) {
	if (lms) return i18n.t(`portal.portalTSX.${lms}`) as string;
	return undefined;
}
